import { CheckIcon, Cross2Icon } from '@radix-ui/react-icons';
import { Badge, Button } from '@radix-ui/themes';
import type { PricingTier } from 'types/misc';
import MembershipLabel from './MembershipLabel';

interface PricingCardProps {
  tier: PricingTier;
}

export function PricingCard({ tier }: PricingCardProps) {
  return (
    <div
      className={`items-center rounded-lg border p-3 shadow-md ${tier.isPopular ? 'row-[1] border-accent-accent-8 bg-accent-accent-3 md:row-auto' : 'bg-white'}`}
    >
      <div className='mb-4 flex flex-col items-center justify-between gap-5'>
        {tier.isPopular ? (
          <MembershipLabel premiumMember={true} premiumClubMember={true} />
        ) : (
          <MembershipLabel premiumMember={false} premiumClubMember={false} />
        )}
        <div className='flex items-center justify-center gap-3'>
          <h2 className='m-0 text-2xl font-bold'>{tier.name}</h2>
          {tier.isPopular && <Badge className='bg-accent-accent-9 px-3 py-1 text-white'>Più popolare</Badge>}
        </div>
      </div>

      <p className='mb-6 text-center'>{tier.description}</p>

      <div className='md:font-5xl mb-6 flex items-baseline justify-center text-3xl font-bold'>
        €{tier.price}
        <span className='ml-2 text-xl font-normal text-neutral-neutral-8 md:text-nowrap'>/{tier.period}</span>
      </div>

      <Button
        variant={tier.isPopular ? 'solid' : 'outline'}
        className='my-5 w-full cursor-pointer rounded-md px-4 py-3'
        onClick={tier.onClick}
      >
        {tier.isPopular ? 'Acquista ora' : 'Gratis'}
      </Button>

      <ul className='mb-6 space-y-3'>
        {tier.features.map((feature, index) => (
          <li
            key={index}
            className={`flex items-center ${feature.included ? 'text-neutral-neutral-11' : 'text-neutral-neutral-7'}`}
          >
            {feature.included ? <CheckIcon className='mr-3' /> : <Cross2Icon className='mr-3' />}
            {feature.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
